export default "__VITE_ASSET__DEZuycpe__"